
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useMutation as useConvexMutation } from "convex/react";
import { api } from "../../api";
import { useToast } from "@/hooks/use-toast";

export const useUpdateRuleScope = () => {
  const queryClient = useQueryClient();
  const updateRuleLevels = useConvexMutation(api.rules.update.levels);
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ 
      ruleId, 
      selectedDeviceIds, 
      selectedLevelIds 
    }: { 
      ruleId: string; 
      selectedDeviceIds: string[]; 
      selectedLevelIds: string[];
    }) => {
      console.log('Updating rule scope:', { ruleId, selectedDeviceIds, selectedLevelIds });

      // Update the rule's level associations
      const result = await updateRuleLevels({
        rule: ruleId as any,
        add: selectedLevelIds.map(id => id as any),
        remove: [] // For now, we'll handle this separately if needed
      });

      console.log('Rule scope updated:', result);
      return result;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['network-rule-scope', variables.ruleId] });
      queryClient.invalidateQueries({ queryKey: ['network-rules'] });
      
      toast({
        title: "Scope Updated",
        description: "Network rule scope has been successfully updated.",
      });
    },
    onError: (error) => {
      console.error('Error updating rule scope:', error);
      toast({
        title: "Error",
        description: error instanceof Error ? error.message : "Failed to update rule scope. Please try again.",
        variant: "destructive",
      });
    }
  });
};
